<template>
  <div class="block">
    <div class="columns is-mobile">
      <div class="column is-8 is-hidden-mobile"/>
      <div class="column is-narrow">
        <div class="title is-5">
          {{ Catalog.TotalWeight.Label }}
        </div>
      </div>
      <div class="column">
        <div class="has-text-right">
          <kst-value class="title is-5" field="TotalWeight" :data="deliveryData" :catalog="Catalog"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Catalog from "../DlvCatalog.js";

export default {
  props: {
    deliveryData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>